import { render, staticRenderFns } from "./OrganicoCard.vue?vue&type=template&id=0813f619&scoped=true"
import script from "./OrganicoCard.vue?vue&type=script&lang=ts"
export * from "./OrganicoCard.vue?vue&type=script&lang=ts"
import style0 from "./OrganicoCard.vue?vue&type=style&index=0&id=0813f619&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0813f619",
  null
  
)

export default component.exports